import React from "react";

import { FolderIcon } from "../../../../../folderIcon";
import { Props } from "./types";
import { FileIcon } from "./fileIcon";
import styles from "./styles.scss";

function Node({ node }: Props) {
  return (
    <div className={styles.node}>
      <div className={styles.iconBox}>
        {node.type === "document" ? (
          <FileIcon className={styles.icon} mimeType={node.mimeType} />
        ) : (
          <FolderIcon className={styles.icon} />
        )}
      </div>
      <p className={styles.name}>{node.name}</p>
    </div>
  );
}

export { Node };
